// removed by extract-text-webpack-plugin
module.exports = {"root":"root___2W-7d","upload-description":"upload-description___2BA6G","preview-img":"preview-img___3BgoP"};


//////////////////
// WEBPACK FOOTER
// ./src/components_business/UploadImage/Index.less
// module id = RT8/
// module chunks = 3 4 10 11